import useDeviceType from "@/app/_hooks/useDeviceType";
import useUpdateWalkThrough from "@/app/_hooks/useUpdateUserWalkThrough";
import { Button, Flex, Group, Paper, Image, Title } from "@mantine/core";
import { useEffect } from "react";
import Logo from "@/app/_media/Logo.svg";
import { WALKTHROUGH_STEP_KEY } from "@/app/_constants/walkthrough";

const WalkThroughToolTip = ({
  continuous,
  index,
  isLastStep,
  step,
  backProps,
  closeProps,
  primaryProps,
  tooltipProps,
}: any) => {
  const { isMobile } = useDeviceType();

  const {
    mutate: handleUpdateWalkThrough,
    isPending: isUpdatingWalkThrough,
    isError: isUpdateWalkThroughIsError,
    isSuccess: isUpdateWalkThroughSuccess,
    error: isUpdateWalkThroughError,
  } = useUpdateWalkThrough();

  useEffect(() => {
    if (isUpdateWalkThroughSuccess) {
      // Flag written: the tour unmounts, so drop the saved resume step.
      try {
        localStorage.removeItem(WALKTHROUGH_STEP_KEY);
      } catch {}
    }
  }, [isUpdateWalkThroughSuccess]);

  return (
    <Paper {...tooltipProps} w={step.title === "Settings" ? 600 : 400} p="md">
      <Flex direction="column" h="100%" w="100%" gap="xs">
        <Group justify="space-between">
          {step.title && <Title order={3}>{step.title}</Title>}{" "}
          {step.title === "Welcome to MountMonitor" && (
            <Image src={Logo.src} alt="MountMonitor Logo" w={48} />
          )}
        </Group>
        <Flex>{step.content}</Flex>
        <Group mt={"xl"} justify="space-between">
          {!isLastStep && !isMobile ? (
            <Button
              variant="subtle"
              color="gray"
              size="compact-sm"
              disabled={isUpdatingWalkThrough}
              onClick={() =>
                handleUpdateWalkThrough({
                  walkThroughCompleted: true,
                  skippedAtStep: index,
                })
              }
            >
              Skip tour
            </Button>
          ) : (
            <span />
          )}
          <Group justify="end">
            {index > 0 && (
              <Button
                disabled={isUpdatingWalkThrough}
                {...backProps}
                aria-label=""
                title=""
                id="back"
                onClick={() => {
                  if (step?.data?.back) {
                    step.data.back();
                  }
                }}
                variant="default"
              >
                Back
              </Button>
            )}
            {continuous && (
              <Button
                loading={isUpdatingWalkThrough}
                {...primaryProps}
                aria-label=""
                title=""
                id="next"
                onClick={async () => {
                  if (step.title === "One more thing") {
                    handleUpdateWalkThrough({ walkThroughCompleted: true });
                  } else {
                    if (step?.data?.next) {
                      step.data.next();
                    }
                  }
                }}
              >
                {step.title === "Welcome to MountMonitor!"
                  ? isMobile
                    ? "Ok"
                    : "Start"
                  : step.title === "One more thing"
                    ? "Finish"
                    : "Next"}
              </Button>
            )}
            {!continuous && (
              <Button {...closeProps} id="close">
                Close
              </Button>
            )}
          </Group>
        </Group>
      </Flex>
    </Paper>
  );
};

export default WalkThroughToolTip;
